<template>
    <v-container>
        <v-row>
            <v-col
                cols="12"
            >
                <v-form
                    ref="form"
                    lazy-validation
                    @submit.prevent
                >
                    <v-row>
                        <v-col cols="4">
                            <SelectReseller
                                v-model="data['filters[resellers]']"
                                label="Parceiros"
                                clearable
                                :return-object="false"
                                multiple
                            ></SelectReseller>
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                :items="integrations"
                                v-model="data['filters[integrations]']"
                                label="Integrações"
                                item-text="label"
                                item-value="value"
                                clearable
                                multiple
                            ></v-select>
                        </v-col>
                        <v-col cols="4">
                            <SelectHolding
                                v-model="data['filters[holdings]']"
                                label="Holdings"
                                clearable
                                :return-object="false"
                                multiple
                            ></SelectHolding>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                                ref="menuPeriod"
                                v-model="menuPeriod"
                                :close-on-content-click="false"
                                :return-value.sync="data['filters[period]']"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                v-if="data['filters[integrations]'] == 'bling'"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        ref="period_input"
                                        v-model="period"
                                        label="Data de vendas"
                                        hint="Filtro por Data de venda selecione início e fim"
                                        placeholder="Data de vendas"
                                        required
                                        prepend-inner-icon="$calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="data['filters[period]']"
                                    no-title
                                    scrollable
                                    range
                                    locale="pt-br"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuPeriod.save(checkDate('period'))"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>

            <v-col
                cols="12"
                class="d-flex justify-end"
            >
                <cp-button
                    class="mr-md-2"
                    :disabled="isLoading"
                    :loading="isLoading"
                    left-icon="$close"
                    @click="clearFilter()"
                >
                    Limpar
                </cp-button>
                <cp-button
                    color="primary"
                    :disabled="isLoading"
                    :loading="isLoading"
                    left-icon="$filterOutline"
                    @click="submit()"
                >
                    Filtrar
                </cp-button>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BaseModel from '@cp-models/BaseModel'
import { redirectClearingFilters } from '@utils/filters'
import SelectReseller from '@core/components/shared/SelectReseller'
import SelectHolding from '@core/components/shared/SelectHolding'

export default {
    components: {
        SelectReseller,
        SelectHolding,
    },
    props: {
        search: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        isLoading: false,
        data: null,
        menuPeriod: false,
        model: new BaseModel,
        integrations: [
            { value: 'bling', label: 'Bling' },
        ],
    }),
    created() {
        this.fillData(this.filters)
    },
    methods: {
        submit() {
            this.clearData()

            this.isLoading = true
            this.redirect(this.route(this.currentRouteName, this.data))
        },
        fillData(filters = {}) {
            this.data = {
                'filters[integrations]': filters.integrations || null,
                'filters[period]': filters.period || null,
                'filters[resellers]': this.normalizeNumericFilter(filters.resellers),
                'filters[holdings]': this.normalizeNumericFilter(filters.holdings),
                'search': this.search
            }
        },
        clearData() {
            this.data = {
                'filters[integrations]': this.data['filters[integrations]'] || null,
                'filters[period]': this.data['filters[period]'] || null,
                'filters[resellers]': this.normalizeNumericFilter(this.data['filters[resellers]']),
                'filters[holdings]': this.normalizeNumericFilter(this.data['filters[holdings]']),
                'search': this.search || null
            }
        },
        clearFilter() {
            redirectClearingFilters(this)
        },

        checkDate(field) {
            if (this.data[`filters[${field}]`] && this.data[`filters[${field}]`][0] && !this.data[`filters[${field}]`][1]) {
                this.data[`filters[${field}]`][1] = this.data[`filters[${field}]`][0]
            }
            this[field] = this.data[`filters[${field}]`]
            return this.data[`filters[${field}]`]
        },
        formatDateRange(field) {
            return this.data[field] && this.data[field][0] && this.data[field][1]
                ? this.model.formatDate(this.data[field][0], true) + ' - ' + this.model.formatDate(this.data[field][1], true)
                : ''
        },
        normalizeNumericFilter(value) {
            if (!value) return null

            const list = Array.isArray(value) ? value : [value]

            const normalized = list
                .map((item) => Number(item))
                .filter((item) => !Number.isNaN(item))

            return normalized.length ? normalized : null
        }
    },

    computed: {
        period: {
            get: function () {
                return this.formatDateRange('filters[period]')
            },
            set: function (newDate) {
                this.data['filters[period]'] = [newDate[0], newDate[1]]
            }
        },
    }
}
</script>
